export default "__VITE_ASSET__80560e82__"